import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth on mount
    const storedToken = localStorage.getItem("santa_catalina_token");
    const storedUser = localStorage.getItem("santa_catalina_user");
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = (tokenData) => {
    const userData = {
      user_id: tokenData.user_id,
      user_type: tokenData.user_type,
      name: tokenData.name,
      casino_id: tokenData.casino_id,
      casino_name: tokenData.casino_name,
      casino_logo: tokenData.casino_logo,
      casino_primary_color: tokenData.casino_primary_color,
      casino_secondary_color: tokenData.casino_secondary_color,
      student_grade: tokenData.student_grade || null
    };
    
    setToken(tokenData.access_token);
    setUser(userData);
    setIsAuthenticated(true);
    
    localStorage.setItem("santa_catalina_token", tokenData.access_token);
    localStorage.setItem("santa_catalina_user", JSON.stringify(userData));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    
    localStorage.removeItem("santa_catalina_token");
    localStorage.removeItem("santa_catalina_user");
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
